/**
 * @generated SignedSource<<e0f71863366dac310b7f4ec1b43f1eea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespAboutTabs_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespAboutItemPanel_user">;
  readonly " $fragmentType": "PdpRespAboutTabs_user";
};
export type PdpRespAboutTabs_user$key = {
  readonly " $data"?: PdpRespAboutTabs_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespAboutTabs_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespAboutTabs_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespAboutItemPanel_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "b5bb7ccef56c5aa9be0d259f3088c6df";

export default node;
